module.exports = __webpack_public_path__ + "img/right-circle-fill.2fb25e21.svg";